import { PublishFiles } from '@/shared/publish';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/publish/')({
    component: RouteComponent,
});

function RouteComponent() {
    // return <div>퍼블 페이지</div>;
    return <PublishFiles />;
}
